module.exports = __webpack_public_path__ + "img/niue.fc733d3c.png";